import { schema } from 'normalizr';

export const userSchema = new schema.Entity('users');

export const commentSchema = new schema.Entity('comments', {
    user: userSchema
})

export const discussionSchema = new schema.Entity('discussions', {
    user: userSchema,
    comments: [commentSchema]
});

export const chatSchema = new schema.Entity('chats', {
    user: userSchema,
    coach: userSchema
});